import { useMemo, useState } from "react";
import { AdminPageHeader } from "../../components/admin/AdminPageHeader";
import { AdminTable } from "../../components/admin/AdminTable";
import { EmptyState } from "../../components/ui/EmptyState";
import { FullPageLoader } from "../../components/ui/FullPageLoader";
import { Input } from "../../components/ui/Input";
import { useAuditLogs } from "../../hooks/useAuditLogs";
import { formatDateTime, titleCase } from "../../lib/format";

export function AdminAuditLogsPage() {
  const [search, setSearch] = useState("");
  const [action, setAction] = useState("");
  const [entityType, setEntityType] = useState("all");
  const filters = useMemo(() => ({ search, action, entityType }), [search, action, entityType]);
  const { data: logs, loading, error } = useAuditLogs(filters);

  return (
    <div>
      <AdminPageHeader title="Audit Logs" description="Review administrative actions, invite acceptance and control changes." />
      <div className="mb-5 grid gap-3 md:grid-cols-3">
        <Input label="Search" value={search} onChange={(event) => setSearch(event.target.value)} />
        <Input label="Action contains" value={action} onChange={(event) => setAction(event.target.value)} />
        <label className="text-sm font-medium text-ink">Entity type
          <select className="mt-2 block w-full rounded-md border border-line bg-field px-3 py-2" value={entityType} onChange={(event) => setEntityType(event.target.value)}>
            {["all", "tenant", "invite", "membership", "profile", "feature_flag"].map((item) => <option key={item} value={item}>{item}</option>)}
          </select>
        </label>
      </div>
      {loading ? <FullPageLoader label="Loading audit logs" /> : null}
      {error ? <EmptyState title="Unable to load audit logs.">{error}</EmptyState> : null}
      {!loading && !error && logs ? (
        <AdminTable headers={["Action", "Tenant", "Actor", "Entity", "Created"]}>
          {logs.map((log) => (
            <tr key={log.id}>
              <td className="px-4 py-3 font-medium text-ink">{titleCase(log.action)}</td>
              <td className="px-4 py-3">{log.tenants?.name ?? "Platform"}</td>
              <td className="px-4 py-3">{log.profiles?.email ?? "System"}</td>
              <td className="px-4 py-3">{log.entity_type ?? "System"}</td>
              <td className="px-4 py-3">{formatDateTime(log.created_at)}</td>
            </tr>
          ))}
        </AdminTable>
      ) : null}
    </div>
  );
}
